import type { ColDef } from "ag-grid-enterprise";
import { QUARTERLY_KEYS } from "../../../../utils/timePeriodUtils";
import type { CalendarType, TimePeriodColumnOptions } from "../columnFactory";
import { baseTimePeriodProperties } from "./baseTimePeriodProperties";
import { getEditableByPlanBy } from "./editableByPlanBy";

/**
 * Creates the 4 quarterly column definitions (Q1–Q4).
 * Quarterly columns are only editable for the inventory_454 calendar type.
 */
export function createQuarterlyColumns(
  calendarType: CalendarType,
  options: TimePeriodColumnOptions
): ColDef[] {
  const {
    planBy,
    planningYear,
    metaData,
    intake,
    editableProducer,
    editableRowPredicate,
    editableMetricsOverride,
    editableTimeWindowPredicate,
    cubeWindow
  } = options;
  const base = baseTimePeriodProperties(
    planBy,
    planningYear,
    metaData,
    cubeWindow,
    editableTimeWindowPredicate !== undefined
  );
  const editable =
    planBy === "SH%" || calendarType !== "inventory_454"
      ? false
      : getEditableByPlanBy({
          planBy,
          planningYear,
          metaData,
          intake,
          editableProducer,
          editableRowPredicate,
          editableMetricsOverride,
          editableTimeWindowPredicate,
          cubeWindow
        });

  return QUARTERLY_KEYS.map((fieldId) => ({
    ...base,
    field: fieldId,
    headerName: metaData.gregMapping[fieldId] ?? fieldId,
    headerTooltip: fieldId,
    editable
  }));
}
